import { MessageDescriptor } from 'react-intl'

import { noop } from 'lodash-es'

import { BenefitGroup } from '../../../models/benefit/Benefit'
import { EssentialsContentSection, EssentialsUpcomingEventData } from '../../essentials/types'

export interface RelatedResourceItem {
  title: string | MessageDescriptor
  image: React.ReactNode
  description: string | MessageDescriptor
  level?: string
  badges?: React.ReactNode[]
  testID?: string
  onPress: () => void
}

export interface GetWomensHealthToolkitPagePropsParams {
  onPressExploreCareOptions: () => void
  userDisplayLanguage?: string
  essentialsSections: EssentialsContentSection[]
  isEssentialsEnabled: boolean
  onSeeMorePress: () => void
  onPressSearchForCare: () => void
  footerLinkPressed: (url: string) => void
  isUserInternational: boolean
  legalNotice?: React.ReactNode
  recommendedBenefitGroupsForUser?: BenefitGroup[]
  allBenefitGroupsForUser?: BenefitGroup[]
  onPressIntegratedBenefit?: (eventProps: {
    benefitClicked: string
    categoryOfClickedBenefit: string
    benefitUrl: string
  }) => void
  onPressShowAllBenefits?: () => void
  onIntegratedBenefitsExplorerLoad?: () => void
  relatedToolkits?: RelatedResourceItem[]
  onPressShowAllToolkits?: () => void
  isLibraryEventsDisabled?: boolean
  upcomingEvents?: EssentialsUpcomingEventData[]
  eventsLoading?: boolean
  onPressUpcomingEssentialsEventsHeaderLink?: () => void
  onPressUpcomingEssentialsEventsCard?: (eventSlug: string) => void
}

export interface WomensHealthToolkitPageProps {
  commonSectionProps: {
    onPressExploreCareOptions: () => void
  }
  essentialsSectionProps: {
    userDisplayLanguage?: string
    essentialsSections?: EssentialsContentSection[]
    isEssentialsEnabled?: boolean
    onSeeMorePress: () => void
    isLibraryEventsDisabled?: boolean
    upcomingEvents?: EssentialsUpcomingEventData[]
    eventsLoading?: boolean
    onPressUpcomingEssentialsEventsHeaderLink?: () => void
    onPressUpcomingEssentialsEventsCard?: (eventSlug: string) => void
  }
  benefitsSectionProps: {
    recommendedBenefitGroupsForUser?: BenefitGroup[]
    allBenefitGroupsForUser?: BenefitGroup[]
    onPressIntegratedBenefit?: (eventProps: {
      benefitClicked: string
      categoryOfClickedBenefit: string
      benefitUrl: string
    }) => void
    onPressShowAllBenefits?: () => void
    onIntegratedBenefitsExplorerLoad?: () => void
  }
  relatedToolkitsSectionProps: {
    relatedToolkits?: RelatedResourceItem[]
    onPressRelatedToolkit?: (toolkitId: string) => void
    onPressShowAllToolkits?: () => void
  }
  footerSectionProps: {
    onPressSearchForCare: () => void
  }
  legalSectionProps: {
    footerLinkPressed: (url: string) => void
    isUserInternational: boolean
    legalNotice?: React.ReactNode
  }
}

export const getWomensHealthToolkitPageProps = ({
  onPressExploreCareOptions = noop,
  onPressSearchForCare = noop,
  onSeeMorePress = noop,
  userDisplayLanguage,
  essentialsSections = [],
  isEssentialsEnabled,
  recommendedBenefitGroupsForUser,
  allBenefitGroupsForUser,
  onPressIntegratedBenefit,
  onPressShowAllBenefits = noop,
  onIntegratedBenefitsExplorerLoad,
  relatedToolkits = [],
  onPressShowAllToolkits = noop,
  footerLinkPressed = noop,
  isUserInternational,
  legalNotice,
  isLibraryEventsDisabled,
  upcomingEvents,
  eventsLoading,
  onPressUpcomingEssentialsEventsHeaderLink,
  onPressUpcomingEssentialsEventsCard,
}: GetWomensHealthToolkitPagePropsParams): WomensHealthToolkitPageProps => {
  return {
    commonSectionProps: {
      onPressExploreCareOptions,
    },
    essentialsSectionProps: {
      userDisplayLanguage,
      essentialsSections,
      isEssentialsEnabled,
      onSeeMorePress,
      isLibraryEventsDisabled,
      upcomingEvents,
      eventsLoading,
      onPressUpcomingEssentialsEventsHeaderLink,
      onPressUpcomingEssentialsEventsCard,
    },
    benefitsSectionProps: {
      recommendedBenefitGroupsForUser,
      allBenefitGroupsForUser,
      onPressIntegratedBenefit,
      onPressShowAllBenefits,
      onIntegratedBenefitsExplorerLoad,
    },
    relatedToolkitsSectionProps: {
      relatedToolkits,
      onPressShowAllToolkits,
    },
    footerSectionProps: {
      onPressSearchForCare,
    },
    legalSectionProps: {
      footerLinkPressed,
      isUserInternational,
      legalNotice,
    },
  }
}
